import { Box, styled } from '@mui/material';

export const OTPContainer = styled(Box)(({ theme }) => ({
  '.ReactOTPInput': {
    gap: theme.spacing(1.5),
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      gap: theme.spacing(1),
      flexWrap: 'wrap',
    },
  },
}));

export const OTPInputCell = styled('input')(({ theme }) => ({
  height: 44,
  minWidth: 40,
  maxWidth: 50,
  flex: 1,
  borderRadius: 10,
  border: `1px solid ${theme.palette.neutral[600]}`,
  fontSize: theme.typography.body2.fontSize,
  transition: theme.transitions.create('border-color'),
  ':active, :focus': {
    outline: 'none',
    borderColor: theme.palette.neutral[1000],
  },
  [theme.breakpoints.down('xs')]: {
    width: 40,
  },
}));
